// Central data for Manoly Baquerizo site
import { PHOTOS, ASSETS } from "./photos";

export { ASSETS, PHOTOS };

export const TRAJECTORY = [
  { years: "2015 — 2016", club: "Montverde Eagles", country: "USA", league: "Youth · High School", tags: ["formacion"], image: null },
  { years: "2016 — 2019", club: "Clayton State University", country: "USA", league: "NCAA · College Athletics", tags: ["formacion", "usa"], image: null },
  { years: "2020 — 2024", club: "CP Cacereño Femenino", country: "España", league: "Consolidación en España", tags: ["cacereno"], image: null, stat: { value: "18", label: "goles · 80 partidos" } },
  { years: "2024 — 2025", club: "Deportivo Alavés Femenino", country: "España", league: "Liga F Challenge", tags: ["alaves"], image: null, stat: { value: "6", label: "goles · 30 partidos" } },
  { years: "2025 — 2026", club: "Granada CF Femenino", country: "España", league: "Liga F", tags: ["granada"], image: PHOTOS.IMG_3531.src, imagePhoto: PHOTOS.IMG_3531, stat: { value: "5", label: "goles · 27 partidos · 6.93 rating" } },
  { years: "2026 — 2028", club: "Paris FC", country: "Francia", league: "Première Ligue · Contrato hasta 2028", tags: ["paris"], image: ASSETS.heroArmsCrossed, current: true, stat: { value: "1", label: "gol en su debut · 06/09/26 vs Nantes (2-0, de cabeza)" } },
];

export const GALLERY = [
  { id: "IMG_3524", photo: PHOTOS.IMG_3524, category: "paris", label: "Paris FC" },
  { id: "IMG_3523", photo: PHOTOS.IMG_3523, category: "paris", label: "Paris FC" },
  { id: "IMG_3522", photo: PHOTOS.IMG_3522, category: "paris", label: "Paris FC" },
  { id: "IMG_3526", photo: PHOTOS.IMG_3526, category: "paris", label: "Paris FC" },
  { id: "IMG_3536", photo: PHOTOS.IMG_3536, category: "seleccion", label: "Ecuador · Brasil 2027" },
  { id: "IMG_3527", photo: PHOTOS.IMG_3527, category: "seleccion", label: "Selección" },
  { id: "IMG_3528", photo: PHOTOS.IMG_3528, category: "seleccion", label: "Selección" },
  { id: "IMG_3535", photo: PHOTOS.IMG_3535, category: "seleccion", label: "Selección" },
  { id: "IMG_3534", photo: PHOTOS.IMG_3534, category: "seleccion", label: "Selección" },
  { id: "IMG_3529", photo: PHOTOS.IMG_3529, category: "seleccion", label: "Selección" },
  { id: "IMG_3533", photo: PHOTOS.IMG_3533, category: "granada", label: "Granada CF" },
  { id: "IMG_3531", photo: PHOTOS.IMG_3531, category: "granada", label: "Granada CF" },
  { id: "IMG_3532", photo: PHOTOS.IMG_3532, category: "granada", label: "Granada CF" },
  { id: "IMG_3530", photo: PHOTOS.IMG_3530, category: "granada", label: "Granada CF" },
];

export const SOCIAL = {
  instagram: "https://www.instagram.com/manolybaquerizo",
  instagramHandle: "@manolybaquerizo",
};
